import { useEffect, useRef, useState } from "react";
import styles from "./Trendyol.module.scss";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import OrderRow from "../../../components/pages/courier/OrderRow";
import { TrendyolOtpDataType } from "../../../interface/site.interface";
import { TrendyolService } from "../../../services/trendyol.service";
import Spinner from "../../../components/shared/spinner/Spinner";
import Card from "../../../components/pages/card/Card";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";
// const array = [
//   {
//     subject: 'Trendyol2',
//     message: 'Trendyol adress deyisikliyi icin dogrulama kodunuz 9983283 7373',
//     code: '22228282',
//     created_at: '2024-12-09 06:11:27',
//     updated_at: '2025-03-12 11:33:44',
//     expired_at: '2025-06-14 04:22:56',
//   },
// ];

function TrendyolOtp() {
  const [trendyolOtp, setTrendyolOtp] = useState<TrendyolOtpDataType[]>([]);
  const [loading, setLoading] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);
  const dispatch = useDispatch<AppDispatch>();
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    setLoading(true);
    TrendyolService.GetTrendYolOtpCode()
      .then((res) => {
        setTrendyolOtp(res.data.otp);
      })
      .catch(() => console.log("err"))
      .finally(() => setLoading(false));
  }, [language]);

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  return (
    <>
      <TitleUpdater
        title={
          data?.colibri && data?.auth_left_sidebar_trendyol_otp
            ? `${data?.colibri} | ${data?.auth_left_sidebar_trendyol_otp}`
            : "Colibri"
        }
      />
      <div>
        {loading ? (
          <Spinner size="large" />
        ) : trendyolOtp.length !== 0 ? (
          <table className={styles.order_history_list}>
            <thead>
              <tr>
                <th>{data?.trendyol_code}</th>
                <th>{data?.trendyol_subject}</th>
                <th>{data?.trendyol_message}</th>
                <th>{data?.trendyol_created_at}</th>
                <th>{data?.trendyol_expired_at}</th>
              </tr>
            </thead>
            <tbody>
              {trendyolOtp?.map((order, index) => (
                <OrderRow key={index} {...order} trendyol={true} />
              ))}
            </tbody>
          </table>
        ) : (
          <div className={styles.empty_wrapper}>
            <div className={styles.empy_packages}>
              {data?.auth_trendyol_empty}
            </div>
          </div>
        )}
      </div>

      <div className={styles.courier_card}>
        {trendyolOtp?.map((order, index) => (
          <Card key={index} {...order} trendyol={true} />
        ))}
      </div>
    </>
  );
}

export default TrendyolOtp;
